module.exports = __webpack_public_path__ + "static/mark-d70e460ac882fa65984a50e4bdab094f.jpg";